class FreeShipping extends SearchForm {
  constructor() {
    super();
    
    // Get cart amount and free shipping threshold (both in cents)
    this.cartAmount = parseInt(this.dataset.amount) || 0;
    this.freeShippingThreshold = parseInt(this.dataset.threshold);
    
    // Simple progress calculation: (current cart amount / free shipping threshold) * 100
    let progress = (this.cartAmount / this.freeShippingThreshold) * 100;
    
    // Ensure progress is between 0 and 100
    progress = Math.min(100, Math.max(0, progress));
    
    // Get our elements
    this.progressBar = this.querySelector('.free-shipping__progress-bar');
    this.metMessage = this.querySelector('[data-free-shipping="true"]');
    this.unmetMessage = this.querySelector('[data-free-shipping="false"]');
    
    // Set the progress bar width
    this.progressBar.style.width = `${progress}%`;
    
    // Show appropriate message
    if (progress >= 100) {
      this.metMessage.removeAttribute('aria-hidden');
      this.unmetMessage.setAttribute('aria-hidden', 'true');
    } else {
      this.unmetMessage.removeAttribute('aria-hidden');
      this.metMessage.setAttribute('aria-hidden', 'true');
      
      // Calculate remaining amount
      const remaining = this.freeShippingThreshold - this.cartAmount;
      const remainingFormatted = (remaining / 100).toFixed(2);
      this.querySelector('[data-amount]').textContent = remainingFormatted;
    }

    this.classList.add('free-shipping--active');
  }
}

customElements.define('free-shipping', FreeShipping);
